<div *ngIf="!linkmode" [ngSwitch]="template">
  <ng-container *ngSwitchCase="'internal'">
    <a [href]="url" *ngIf="redirectViaServer" [class.-link-active]="isLinkActive(url)" (click)="handleRedirect($event, url)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <lucide-icon *ngIf="showchevron" name="chevron-right" class="chevron-icon"></lucide-icon>
    </a>
    <a [routerLink]="url" *ngIf="!redirectViaServer" [class.-link-active]="isLinkActive(url)" [queryParams]="tree.queryParams" [fragment]="tree.fragment" (click)="handleClick()">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <lucide-icon *ngIf="showchevron" name="chevron-right" class="chevron-icon"></lucide-icon>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'external'">
    <a [href]="to" target="_blank" rel="noopener noreferrer">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <!-- <span class="wpdh-icon wpdh-icon--external wpdh-icon--margin-left"></span> -->
      <icon icon="external-link" class="-xsm"></icon>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'noRoute'">
    <a target="_blank" rel="noopener noreferrer">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'newTab'">
    <a [href]="to" target="_blank" rel="noopener noreferrer">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </ng-container>
</div>


<ng-container *ngIf="linkmode && linkmode === 'apispec'">
  <a [class]="display" [href]="to">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>


<ng-container *ngIf="linkmode && linkmode === 'preNavigate'">
  <a [class]="display" [href]="to" (click)="onPreNavigateClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>